import {AclRole} from "../shared/models/acl.model";
import * as UserRoles from './UserRoles';

export interface IACLRULES {
    // DASHBOARD: AclRole[];
    // LABS: AclRole[];
    // LAB_ADD: AclRole[];
    // LAB_DETAILS: AclRole[];
    // LAB_EDIT: AclRole[];
    // FACILITY: AclRole[];
    // FACILITY_ADD: AclRole[];
    // FACILITY_DETAILS: AclRole[];
    // FACILITY_DETAILS_LOCATIONS_ROUTE: AclRole[];
    // LOCATION: AclRole[];
    // LOCATION_ADD: AclRole[];
    // LOCATION_DETAILS: AclRole[];
    // LOCATION_DETAILS_TEST_ORDER_ROUTE: AclRole[];
    //
    // PATIENT: AclRole[];
    // PATIENT_ADD: AclRole[];
    // PATIENT_DETAILS: AclRole[];
    // TEST_ORDER: AclRole[];
    TEST_ORDER_FACILITY_FILTER: AclRole[];
    TEST_ORDER_LOCATION_FILTER: AclRole[];
    // TEST_ORDER_VIEW: AclRole[];
    // TEST_ORDER_ADD: AclRole[];
    // TEST_ORDER_CSV_DOWNLOAD: AclRole[];
    // TEST_ORDER_CANCEL: AclRole[];
    // SAMPLE_ACTIVITY_LOGS: AclRole[];
    // SAMPLE_LIST: AclRole[];
    // SAMPLE_LIST_MARK_AS_SEND_OUT: AclRole[];
    // SAMPLE_LIST_CSV_DOWNLOAD: AclRole[];
    // SAMPLE_LIST_UPLOAD_RESULT: AclRole[];
    // ACCESSIONING: AclRole[];
    // TEST_PANEL: AclRole[];
    // TEST_PANEL_ADD: AclRole[];
    // TEST_PANEL_EDIT: AclRole[];
    // TEST_PANEL_CSV_DOWNLOAD_ADD: AclRole[];
    // TEST_PANEL_DETAILS_ROUTE: AclRole[];
    // RESULT: AclRole[];
    // IMPORT_RESULT_XLS: AclRole[];
    // SEND_OUTS: AclRole[];
    // QR_CODES: AclRole[];
    // BULK_UPLOAD: AclRole[];
    BULK_TEST_ORDER_IMPORT_FORM_FACILITY: AclRole[];
    BULK_TEST_ORDER_IMPORT_FORM_LOCATION: AclRole[];
    // STATE_REPORTING_LIST: AclRole[];
    // BARCODES_LIST: AclRole[];
    // QR_CODE_FORM_FACILITY_FIELD:AclRole[];
    // QR_CODE_FORM_LOCATION_FIELD:AclRole[];
    // SYSTEM_SETTINGS: AclRole[];
    // ACCESS_LEVEL: AclRole[];
    // ACCESS_LEVEL_LIST: AclRole[];
}


export const ACL_RULES: IACLRULES = {
    // DASHBOARD: [UserRoles.SUPER_ADMIN, UserRoles.LAB_ADMIN, UserRoles.LAB_USER, UserRoles.CRM_ADMIN,UserRoles.FACILITY_ADMIN,UserRoles.LOCATION_ADMIN],
    // LABS: [UserRoles.SUPER_ADMIN, UserRoles.CRM_ADMIN, UserRoles.LAB_ADMIN],
    // LAB_ADD: [UserRoles.SUPER_ADMIN, UserRoles.LAB_ADMIN],
    // LAB_DETAILS: [UserRoles.SUPER_ADMIN, UserRoles.LAB_ADMIN,UserRoles.CRM_ADMIN],
    // LAB_EDIT: [UserRoles.SUPER_ADMIN, UserRoles.LAB_ADMIN],
    // FACILITY: [UserRoles.SUPER_ADMIN, UserRoles.CRM_ADMIN],
    // FACILITY_ADD: [UserRoles.SUPER_ADMIN, UserRoles.CRM_ADMIN],
    // FACILITY_DETAILS_LOCATIONS_ROUTE: [UserRoles.SUPER_ADMIN, UserRoles.CRM_ADMIN],
    // FACILITY_DETAILS: [UserRoles.SUPER_ADMIN, UserRoles.CRM_ADMIN],
    //
    // LOCATION: [UserRoles.SUPER_ADMIN, UserRoles.CRM_ADMIN, UserRoles.FACILITY_ADMIN],
    // LOCATION_ADD: [UserRoles.SUPER_ADMIN, UserRoles.CRM_ADMIN, UserRoles.FACILITY_ADMIN],
    // LOCATION_DETAILS_TEST_ORDER_ROUTE: [UserRoles.SUPER_ADMIN, UserRoles.CRM_ADMIN, UserRoles.FACILITY_ADMIN],
    // LOCATION_DETAILS: [UserRoles.SUPER_ADMIN, UserRoles.CRM_ADMIN, UserRoles.FACILITY_ADMIN],
    //
    // PATIENT: [UserRoles.SUPER_ADMIN, UserRoles.FACILITY_ADMIN, UserRoles.LOCATION_ADMIN, UserRoles.CRM_ADMIN],
    // PATIENT_ADD: [UserRoles.SUPER_ADMIN, UserRoles.FACILITY_ADMIN, UserRoles.LOCATION_ADMIN, UserRoles.CRM_ADMIN],
    // PATIENT_DETAILS: [UserRoles.SUPER_ADMIN, UserRoles.FACILITY_ADMIN, UserRoles.LOCATION_ADMIN, UserRoles.CRM_ADMIN],
    //
    // TEST_ORDER: [UserRoles.STAR],
    // TEST_ORDER_VIEW: [UserRoles.SUPER_ADMIN, UserRoles.LAB_ADMIN, UserRoles.LAB_USER, UserRoles.CRM_ADMIN,UserRoles.FACILITY_ADMIN,UserRoles.LOCATION_ADMIN],
    TEST_ORDER_FACILITY_FILTER: [UserRoles.SUPER_ADMIN, UserRoles.CRM_ADMIN, UserRoles.LAB_ADMIN],
    TEST_ORDER_LOCATION_FILTER: [UserRoles.SUPER_ADMIN, UserRoles.CRM_ADMIN, UserRoles.LAB_ADMIN, UserRoles.FACILITY_ADMIN],
    // TEST_ORDER_ADD: [UserRoles.SUPER_ADMIN, UserRoles.FACILITY_ADMIN, UserRoles.LOCATION_ADMIN, UserRoles.CRM_ADMIN,],
    // TEST_ORDER_CSV_DOWNLOAD: [UserRoles.SUPER_ADMIN, UserRoles.FACILITY_ADMIN, UserRoles.LOCATION_ADMIN, UserRoles.CRM_ADMIN,UserRoles.BILLING],
    // TEST_ORDER_CANCEL: [UserRoles.SUPER_ADMIN, UserRoles.LOCATION_ADMIN, UserRoles.CRM_ADMIN,],
    // BULK_UPLOAD: [UserRoles.SUPER_ADMIN, UserRoles.FACILITY_ADMIN, UserRoles.LOCATION_ADMIN, UserRoles.CRM_ADMIN,],
    BULK_TEST_ORDER_IMPORT_FORM_FACILITY: [UserRoles.SUPER_ADMIN, UserRoles.CRM_ADMIN, UserRoles.LAB_ADMIN],
    BULK_TEST_ORDER_IMPORT_FORM_LOCATION: [UserRoles.SUPER_ADMIN, UserRoles.CRM_ADMIN, UserRoles.LAB_ADMIN, UserRoles.FACILITY_ADMIN],
    // SAMPLE_ACTIVITY_LOGS: [UserRoles.SUPER_ADMIN, UserRoles.LAB_ADMIN, UserRoles.LAB_USER, UserRoles.CRM_ADMIN, UserRoles.BILLING],
    //
    // SAMPLE_LIST: [UserRoles.SUPER_ADMIN, UserRoles.LAB_ADMIN, UserRoles.LAB_USER, UserRoles.CRM_ADMIN, UserRoles.BILLING],
    // SAMPLE_LIST_MARK_AS_SEND_OUT: [UserRoles.SUPER_ADMIN, UserRoles.LAB_ADMIN, UserRoles.LAB_USER],
    // SAMPLE_LIST_UPLOAD_RESULT: [UserRoles.SUPER_ADMIN, UserRoles.LAB_ADMIN, UserRoles.LAB_USER],
    // SAMPLE_LIST_CSV_DOWNLOAD:[UserRoles.SUPER_ADMIN, UserRoles.LAB_ADMIN, UserRoles.LAB_USER,  UserRoles.BILLING],
    //
    // TEST_PANEL: [UserRoles.SUPER_ADMIN, UserRoles.LAB_ADMIN, UserRoles.LAB_USER, UserRoles.CRM_ADMIN,UserRoles.FACILITY_ADMIN,UserRoles.LOCATION_ADMIN],
    // TEST_PANEL_ADD: [UserRoles.SUPER_ADMIN, UserRoles.LAB_USER,UserRoles.LAB_ADMIN],
    // TEST_PANEL_CSV_DOWNLOAD_ADD: [UserRoles.SUPER_ADMIN, UserRoles.CRM_ADMIN, UserRoles.LAB_ADMIN,UserRoles.LAB_USER],
    // TEST_PANEL_EDIT: [UserRoles.SUPER_ADMIN, UserRoles.LAB_USER,UserRoles.LAB_ADMIN],
    // TEST_PANEL_DETAILS_ROUTE: [UserRoles.STAR],
    //
    // ACCESSIONING: [UserRoles.SUPER_ADMIN, UserRoles.LAB_ADMIN, UserRoles.LAB_USER, UserRoles.CRM_ADMIN,],
    // RESULT: [UserRoles.SUPER_ADMIN, UserRoles.CRM_ADMIN, UserRoles.LAB_ADMIN,UserRoles.LAB_USER],
    // IMPORT_RESULT_XLS: [UserRoles.SUPER_ADMIN, UserRoles.LAB_ADMIN,UserRoles.LAB_USER],
    // SEND_OUTS: [UserRoles.SUPER_ADMIN, UserRoles.CRM_ADMIN, UserRoles.LAB_ADMIN,UserRoles.LAB_USER],
    // QR_CODES: [UserRoles.SUPER_ADMIN, UserRoles.LOCATION_ADMIN, UserRoles.FACILITY_ADMIN, UserRoles.CRM_ADMIN],
    // QR_CODE_FORM_FACILITY_FIELD : [UserRoles.SUPER_ADMIN, UserRoles.CRM_ADMIN],
    // QR_CODE_FORM_LOCATION_FIELD : [UserRoles.SUPER_ADMIN, UserRoles.CRM_ADMIN,UserRoles.FACILITY_ADMIN],
    //
    // STATE_REPORTING_LIST: [UserRoles.SUPER_ADMIN, UserRoles.CRM_ADMIN],
    //
    // BARCODES_LIST: [UserRoles.SUPER_ADMIN, UserRoles.CRM_ADMIN],
    //
    // SYSTEM_SETTINGS: [UserRoles.SUPER_ADMIN, UserRoles.CRM_ADMIN],
    //
    // ACCESS_LEVEL: [UserRoles.SUPER_ADMIN, UserRoles.CRM_ADMIN],
    // ACCESS_LEVEL_LIST: [UserRoles.SUPER_ADMIN, UserRoles.CRM_ADMIN],
};
